import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18065a25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = { class: "order-num" }
const _hoisted_3 = { class: "el-dialog__body-footer flex-ter-end" }

import { t } from '@/plugins/i18n'
import { ElMessage } from 'element-plus'
import { ref, watch, nextTick } from 'vue'
import { priorityShipping } from '@/apis/order'
import { canDeliveryPriority } from './data'
import OrderItemTable from '../OrderItemTable.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowItem: {
    type: Object,
    default: () => ({})
  },
  dataList: {
    type: Array,
    default: () => []
  }
},
  emits: ['update:visible', 'refresh'],
  setup(__props, { emit }) {

const props = __props




watch(() => props.visible, (newValue) => {
  if (newValue) {
    toggleAll()
  }
})

const tableConfig = {
  showSelection: true,
  showExpand: true,
  rowKey: 'platformOrderItemId',
  expandConfigId: 'combinationOrderItemList',
  selectable: (row: any) => canDeliveryPriority(row)
}

const columns:any = [
  {
    label: t('商品信息'),
    prop: 'shoppingInfo',
    align: 'center',
    width: 230,
    slotName: 'shoppingInfo'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'productPropertiesName'
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    slotName: 'productSku'
  },
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'shoppingStats'
  },
  {
    label: t('下单数量'),
    prop: 'orderQuantity',
    align: 'center'
  }
]

const STableRef = ref()
const toggleAll = () => {
  nextTick(() => {
    STableRef.value && STableRef.value.toggleAll()
  })
}

const selectionList: any = ref([])
const handleSelection = (val: any[]) => {
  selectionList.value = val
}

const close = () => {
  emit('update:visible', false)
  selectionList.value = []
}

const submit = () => {
  if (!selectionList.value.length) return ElMessage.warning(t('请选择需要优先发货的商品'))
  priorityShipping(
    selectionList.value.map((e: any) => ({
      platformOrderId: e.platformOrderId, platformOrderItemId: e.platformOrderItemId
    }))
  ).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('优先发货成功'))
      close()
      emit('refresh')
    }
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.visible,
    "destroy-on-close": "",
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('请确认优先发货信息')), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('THE CKB订单编号')) + ": " + _toDisplayString(__props.rowItem.platformOrderNo), 1),
      _createElementVNode("div", null, [
        _createVNode(OrderItemTable, {
          ref: (_value, _refs) => {
            _refs['STableRef'] = _value
            STableRef.value = _value
          },
          dataList: __props.dataList,
          columns: columns,
          tableConfig: tableConfig,
          onSelectionChange: handleSelection
        }, null, 8, ["dataList"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, { onClick: close }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        (__props.dataList.some((v) => _unref(canDeliveryPriority)(v)))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              onClick: submit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})